module.exports = __webpack_public_path__ + "static/tabitha-phone-hand-152fa4f8dd6e10eaeb649e0cf2c7f737.png";